import Table from "react-bootstrap/Table";
import React, { Component } from "react";

function BillTable(props) {
  if (!props.data) {
    return <div>Loading...</div>;
  }
  return (
    <div>
      <Table responsive hover size="sm" striped="columns">
        <thead>
          <tr>
            {props.headercolumns !== null
              ? props.headercolumns.map((column) => (
                  <th className="text-center color-white" key={column.id}>
                    {column}
                  </th>
                ))
              : ""}
          </tr>
        </thead>
        <tbody>
          {props.data.map((row, index) => (
            <tr key={row.id} onClick={() => props.setSelectedRow(index, row)}>
              {props.columns.map((column) => (
                <td className="text-center color-white" key={column}>
                  {row[column]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default BillTable;
